// Imports => Utilities
import {AcIsSet, AcIsArray, AcIsObject, AcIsEmptyString} from './ac-get-type-of';

export const AcFormatRequestParameters = (
  {query, order, perpage, page},
  options,
  optionsOnly = false
) => {
  let params = {};

  if (!optionsOnly) {
    if (AcIsSet(query) && !AcIsEmptyString(query)) {
      params.q = query;
    }

    if (AcIsSet(order) && AcIsSet(order.field)) {
      const direction = order.direction === KEYS.ASCENDING ? '' : '-';
      params.order = `${direction}order.field`;
    }

    if (AcIsSet(perpage) && perpage !== 0) {
      params.perpage = perpage;
    }

    if (AcIsSet(page) && page !== 0) {
      params.page = page;
    }
  }

  if (AcIsSet(options) && AcIsObject(options)) {
    for (let opt in options) {
      if (AcIsArray(options[opt])) {
        params[opt] = options[opt];
      } else params[opt] = options[opt];
    }
  }

  return params;
};
